import * as React from 'react';

const Req = () => {
    return (
        <span className={'req'} aria-hidden={'true'}>*</span>
    )
}

export default Req
